import React, { useEffect, useState } from "react";
import { useNavigation } from "react-router-dom";
import {
  addOrderItemOffer,
  deleteAllOrderItemOffer,
  deleteSingleOfferOrderItem,
  getOrderItemGarmentServiceOffer,
  getOrderItemOffer,
} from "../../services/OrderEditOffer/OrderEditOffer";
import { Checkbox } from "primereact/checkbox";
import BookNewOrderModal from "./BookNewOrderModal";
import { Button } from "primereact/button";
import { getStoreLocalData } from "../../utils/localStorage";

const BottomSheetViewFormOfferEdit = ({
  selectedGarment,
  onAddToCart,
  onClose,
  storeId,
  storeCustomerId,
  // selectedPriceId,
  BookingType,
  offerPriceEnabled,
  storeUserId,
  bookingOrderId,
  brandId,
  priceId,
}) => {
  const selectedPriceId = priceId;
  const navigate = useNavigation();

  const { storeLocalData } = getStoreLocalData();

  // New state variables for error messages
  const [isGarmentViewDisable, setIsGarmentViewDisable] = useState(false);
  const [isGarmentButtonPressed, setIsGarmentButtonPressed] = useState(false);

  const [modalVisible, setModalVisible] = useState(false);
  const [appliedOfferData, setAppliedOfferData] = useState([]);
  const [allServicesOfferData, setAllServicesOfferData] = useState({});
  const [removeOfferModal, setRemoveOfferModal] = useState(false);

  const [selectedItems, setSelectedItems] = useState({});
  const [messageDisplay, setMessageDisplay] = useState(false);

  const fetchOrderItemOffer = async () => {
    try {
      const response = await getOrderItemOffer(
        storeId,
        storeCustomerId,
        bookingOrderId,
        selectedGarment.addOns[0].orderItemId
      );
      if (!response.data.error) {
        setAppliedOfferData(response.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchOrderItemGarmentServiceOffer = async () => {
    try {
      const response = await getOrderItemGarmentServiceOffer(
        storeId,
        storeCustomerId,
        bookingOrderId,
        selectedGarment.addOns[0].orderItemId
      );
      if (!response.data.error) {
        setAllServicesOfferData(response.data.cartAddOnOfferMapList);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  function calculateTotalAmount(data) {
    let sum = 0;
    data.addOns.forEach((item) => {
      sum += item.totalPrice;
    });

    return sum;
  }

  // Calculate the sum of offerAmount
  const totalSum = calculateTotalAmount(selectedGarment);

  function calculateTotalAppliedOfferAmount(data) {
    let sum = 0;
    data.forEach((item) => {
      sum += item.offerAmount;
    });

    return sum;
  }

  // Calculate the sum of offerAmount
  const totalAppliedOfferSum =
    calculateTotalAppliedOfferAmount(appliedOfferData);

  useEffect(() => {
    fetchOrderItemOffer();
    fetchOrderItemGarmentServiceOffer();
  }, []);

  useEffect(() => {
    if (modalVisible) {
      // Set a timeout to close the modal after 2000 milliseconds (2 seconds)
      const timeoutId = setTimeout(() => {
        onClose(); // Call the onClose callback
        setModalVisible(false); // Close the modal by updating state
      }, 500);

      // Clear the timeout if the component unmounts or modalVisible changes
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [modalVisible, onClose]);

  const [addOns, setAddOns] = useState(selectedGarment.addOns);

  const offerData = addOns.flatMap((addOnItem) =>
    (allServicesOfferData[addOnItem.id] || []).map((offer) => ({
      // ...offer,
      addOnServiceName: addOnItem.serviceName,
      addOnServiceTotalPrice: addOnItem.totalPrice,
      addOnItemId: addOnItem.id,
      isSelected: false,
      offerName: offer.brandOfferItemDTO.brandOffer.name,
      offerCount: offer.count,
      offer: offer,
      offerAmount: offer.offerAmount,
    }))
  );

  function calculateSumOfferAmount(data) {
    let sum = 0;

    // Iterate over each itemId
    Object.keys(data).forEach((itemId) => {
      // Skip sumOfferAmount key
      if (itemId !== "sumOfferAmount") {
        // Iterate over each offer under the current itemId
        data[itemId].forEach((offer) => {
          sum += offer.offerAmount;
        });
      }
    });

    return sum;
  }

  // Calculate the sum of offerAmount
  const offerDiscountSum = calculateSumOfferAmount(selectedItems);

  const handleEditGarment = (event) => {
    // Check if the button has already been pressed

    event.preventDefault();
    if (!isGarmentButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsGarmentButtonPressed(true);
      setIsGarmentViewDisable(true);
      const newOffer = {
        cartAddOnOfferMapList: Object.fromEntries(
          Object.entries(selectedItems).map(([key, value]) => [
            key,
            value.map(({ addOnServiceName, ...rest }) => rest),
          ])
        ),
      };

      addOrderItemOffer(
        storeId,
        storeCustomerId,
        bookingOrderId,
        selectedGarment.addOns[0].orderItemId,
        newOffer
      )
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            // Call the onAddToCart callback to add the garment to the cart
            setModalVisible(true);
            setIsGarmentButtonPressed(false);
            setIsGarmentViewDisable(false);
            if (Res) {
              navigate("OrdersGarmentInfo", {state:{
                bookingOrderId: bookingOrderId,
                storeCustomerId: storeCustomerId,
              }});
            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  const removeOffer = async (offerId) => {
    try {
      const response = await deleteSingleOfferOrderItem(
        storeId,
        storeCustomerId,
        bookingOrderId,
        selectedGarment.addOns[0].orderItemId,
        offerId
      );
      if (!response.data.error) {
        // Update the cart details and other data
        fetchOrderItemOffer();
        fetchOrderItemGarmentServiceOffer();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const receiveDataFromOfferRemoveModal = ({ dataRes }) => {
    // setSchedularDate(newSchedular);
    if (dataRes) removeAllOffer();
  };

  const removeAllOffer = async () => {
    try {
      const response = await deleteAllOrderItemOffer(
        storeId,
        storeCustomerId,
        bookingOrderId,
        selectedGarment.addOns[0].orderItemId
      );
      if (!response.data.error) {
        // Update the cart details and other data
        fetchOrderItemOffer();
        fetchOrderItemGarmentServiceOffer();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSelectOffer = (itemId, offer) => {
    // Calculate the current sum of offer amounts for all selected offers
    const currentOfferSum = Object.values(selectedItems).reduce(
      (total, itemOffers) => {
        return (
          total +
          itemOffers.reduce(
            (itemTotal, selectedOffer) => itemTotal + selectedOffer.offerAmount,
            0
          )
        );
      },
      0
    );

    // Calculate the sum of applied offer amounts for each service
    const appliedOfferAmounts = appliedOfferData.reduce((acc, item) => {
      if (!acc[item.orderItemAddOn.serviceName]) {
        acc[item.orderItemAddOn.serviceName] = 0;
      }
      acc[item.orderItemAddOn.serviceName] += item.offerAmount;
      return acc;
    }, {});

    // Calculate the available amount for the specific service
    const availableServiceAmount =
      offer.addOnServiceTotalPrice -
      (appliedOfferAmounts[offer.addOnServiceName] || 0);

    setSelectedItems((prevSelectedItems) => {
      const itemOffers = prevSelectedItems[itemId] || [];
      const offerIndex = itemOffers.findIndex(
        (selectedOffer) =>
          selectedOffer.brandOfferItemDTO.id ===
          offer.offer.brandOfferItemDTO.id
      );

      // Calculate the potential new sum if the offer were removed
      let offerToRemoveAmount = 0;
      if (offerIndex > -1) {
        offerToRemoveAmount = itemOffers[offerIndex].offerAmount;
      }

      // Calculate the sum of offerAmount for the same addOnServiceName
      const currentServiceOfferSum = itemOffers.reduce(
        (total, selectedOffer) => {
          if (selectedOffer.addOnServiceName === offer.addOnServiceName) {
            return total + selectedOffer.offerAmount;
          }
          return total;
        },
        0
      );

      if (offerIndex > -1) {
        // If offer is already selected, remove it by its index
        const updatedOffers = itemOffers.filter(
          (_, index) => index !== offerIndex
        );

        // If there are remaining offers for the item, update state with those offers
        if (updatedOffers.length > 0) {
          return { ...prevSelectedItems, [itemId]: updatedOffers };
        } else {
          // If no offers left for the item, remove the item from selected items
          const { [itemId]: omit, ...restSelectedItems } = prevSelectedItems;
          return restSelectedItems;
        }
      } else {
        // Otherwise, add it to selected items if it doesn't exceed totalAmountSum and addOnService total price
        const newServiceOfferSum = currentServiceOfferSum + offer.offerAmount;
        if (
          currentOfferSum + offer.offerAmount <=
            totalSum - totalAppliedOfferSum &&
          newServiceOfferSum <= availableServiceAmount
        ) {
          return {
            ...prevSelectedItems,
            [itemId]: [
              ...itemOffers,
              {
                brandOfferItemDTO: { id: offer.offer.brandOfferItemDTO.id },
                offerAmount: offer.offerAmount,
                count: offer.offer.count,
                addOnServiceName: offer.addOnServiceName,
              },
            ],
          };
        } else {
          setMessageDisplay(true);
          // alert('Offer Value Can not be more than Garment Service Value');
          return prevSelectedItems; // Return current state without modifying
        }
      }
    });
  };

  const renderAppliedOfferItem = () => {
    return appliedOfferData?.map((item, index) => (
      <div>
        <div>
          <div>
          <div className="flex align-items-center">
              <img
                src={"Laundy_App_Icons_Gifs/SettingIcons/gift.png"}
                style={{
                  width: 25,
                  height: 25,
                }}
              />
              <div
                className=" flex my-2 mx-1 border-round-md shadow-4"
                style={{
                  borderRadius: 5,
                  backgroundImage:
                    "radial-gradient(circle at left top, #2E3192, #ffffff)",
                  flex: 1,
                }}
              >
                <div
                  className="flex-row flex justify-content-between align-items-center py-1 px-2"
                  key={index}
                >
                  <p className=" text-xl text-white font-medium capitalize">
                    {item.brandOfferItem.brandOffer.name} -{" "}
                    {item.orderItemAddOn.serviceName}
                  </p>
                  <p className=" text-xl text-white font-medium capitalize">{item.count}</p>
                  <p className=" text-xl font-medium capitalize">{storeLocalData?.currencySymbol} {item.offerAmount}</p>
                </div>
              </div>
              <div
                style={{
                  alignSelf: "center",
                  top: 5,
                  paddingLeft: 5,
                }}
              >
                <div className="cursor-pointer" onClick={() => removeOffer(item.id)}>
                  <img
                    src={
                      "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const renderAllOfferItem = () => {
    return offerData?.map((item, index) => (
      <div>
        <div>
          <div>
            <div className="flex align-items-center">
              <img
                src={"Laundy_App_Icons_Gifs/SettingIcons/gift.png"}
                style={{
                  width: 25,
                  height: 25,
                }}
              />
              <div
                className=" flex my-2 mx-1 border-round-md shadow-4"
                style={{
                  borderRadius: 5,
                  backgroundImage:
                    "radial-gradient(circle at left top, #2E3192, #ffffff)",
                  flex: 1,
                }}
              >
                <div
                  className="flex-row flex justify-content-between align-items-center py-1 px-2"
                  key={index}
                >
                  <p className=" text-xl text-white font-medium capitalize">
                    {item.offerName} - {item.addOnServiceName}
                  </p>
                  <p className=" text-xl text-white font-medium capitalize">
                    {item.offerCount}
                  </p>
                  <p className=" text-xl text-white font-medium capitalize">
                    {storeLocalData?.currencySymbol} {item.offerAmount}
                  </p>
                  <Checkbox
                    checked={(selectedItems[item.addOnItemId] || []).some(
                      (selectedOffer) =>
                        selectedOffer.brandOfferItemDTO.id ===
                        item.offer.brandOfferItemDTO.id
                    )}
                    color={
                      (selectedItems[item.addOnItemId] || []).some(
                        (selectedOffer) =>
                          selectedOffer.brandOfferItemDTO.id ===
                          item.offer.brandOfferItemDTO.id
                      )
                        ? "#2E3192"
                        : "#2E3192"
                    }
                    onClick={() => handleSelectOffer(item.addOnItemId, item)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div>
      <div>
        <div style={{pointerEvents:isGarmentViewDisable ? "none" : "auto"}}>
          {totalAppliedOfferSum > 0 && (
            <div>
              <p className="mt-3 mb-1 text-xl  font-medium capitalize">Total Applied Offer Sum {storeLocalData?.currencySymbol} {totalAppliedOfferSum}</p>
            </div>
          )}
          {appliedOfferData.length > 0 && (
            <div style={{ marginTop: 10 }}>
              <div
                className="ml-1 py-1 flex-1"
                style={{
                  backgroundColor: "#6EA4F5",
                  borderRadius: 5,
                }}
              >
                <div className="ml-4">
                  <p className="text-2xl font-bold text-white">Applied Offer</p>
                </div>
              </div>

              {renderAppliedOfferItem()}
              <div className="m-2">
                <div className="cursor-pointer"
                  onClick={() => setRemoveOfferModal(true)}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <p className="mx-2 text-lg font-medium capitalize text-center" style={{color:"red"}}>Remove All</p>
                  <img
                    src={
                      "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                    }
                    
                  />
                </div>
              </div>
            </div>
          )}
          {offerData.length > 0 && (
            <div>
              <div style={{ marginTop: 10 }}>
                <div
                  className="ml-1 py-1 flex-1"
                  style={{
                    backgroundColor: "#6EA4F5",
                    borderRadius: 5,
                  }}
                >
                  <div className="ml-4">
                    <p className="text-2xl font-bold text-white">
                      Available Offer
                    </p>
                  </div>
                </div>

                {renderAllOfferItem()}
              </div>

              <div className="flex-1 mx-2 mb-1 mt-3">
                <div className=" flex justify-content-center">
                  <Button
                    label="Update"
                    onClick={handleEditGarment}
                    disabled={isGarmentButtonPressed}
                    className=" text-2xl w-full border-round-xl border-none cursor-pointer"
                  ></Button>
                </div>
              </div>
            </div>
          )}
          {offerData.length === 0 && (
            <div>
              <p className=" text-3xl font-medium capitalize text-center" style={{color:"red"}}>No offer is available </p>
            </div>
          )}
        </div>
        <BookNewOrderModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          onClose={onClose}
          messageType={"offer"}
        />
        {/* <OfferRemoveModal
          setRemoveOfferModal={setRemoveOfferModal}
          removeOfferModal={removeOfferModal}
          sendDataToOfferEditPage={receiveDataFromOfferRemoveModal}
        />
        <OfferMessageModal
          setModalVisible={setMessageDisplay}
          modalVisible={messageDisplay}
        /> */}
      </div>
    </div>
  );
};

export default BottomSheetViewFormOfferEdit;
